import styled, { css } from 'styled-components'

import { color, spacing, typography } from '../../../../../themes'

export const Container = styled.div`
  width: 100%;
  min-width: 200px;
  position: relative;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${spacing(5, 4)};
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 20%);
  background: ${color('white')};
  z-index: 1;

  ${({ hasCloseButton }: { hasCloseButton: boolean }) =>
    !hasCloseButton &&
    css`
      justify-content: center;
    `}
`

export const Title = styled.div`
  ${typography('headline3')};

  ${({ hasCloseButton }: { hasCloseButton: boolean }) =>
    hasCloseButton &&
    css`
      margin-left: auto;
    `}
`

export const CloseWrapper = styled.div.attrs({ role: 'button' })`
  cursor: pointer;
  margin-left: auto;
`
